module.exports = __webpack_public_path__ + "img/winitoutstore.eec7c654.png";